module.exports = __webpack_public_path__ + "img/selfie.8fc66b96.svg";